import { setSelectedTransaction, setTransactionDetailModal } from '../../../../../store/workspace/slice';
import { selectSubscriptionHistory } from '../../../../../store/workspace/selectors';
import { thousandSeparator } from '../../../../../utils/numberHelpers';
import { useDispatch, useSelector } from '../../../../../store/store';
import { Transaction } from '../../../../../store/workspace/types';
import { InformationIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';

/** "Billing History" pane: the invoices Stripe issued for the subscription. */
export default function BillingHistory() {
    const dispatch = useDispatch();
    const subscription = useSelector(selectSubscriptionHistory);
    const payments = subscription?.payments || [];

    const viewTransactionDetail = (transaction: Transaction) => {
        dispatch(setSelectedTransaction(transaction));
        dispatch(setTransactionDetailModal(true));
    };

    return (
        <div className={styles.wrapper}>
            <span className={styles.description}>
                Showing invoices within the past 12 months.
            </span>

            <div className={styles.table}>
                {payments.length > 0 ? <table>
                    <thead>
                        <tr>
                            <th>Invoice</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Created date</th>
                            <th>Billing details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map(item => <tr key={item.invoice_id}>
                            <td>{item.invoice_id}</td>
                            <td>
                                <span className={styles.status} data-status={item.status}>
                                    {item.status}
                                </span>
                            </td>
                            <td>{thousandSeparator(item.amount_paid / 100)}$</td>
                            <td>{new Date(item.created * 1000).toDateString()}</td>
                            <td>
                                <span
                                    className={styles.link}
                                    onClick={() => viewTransactionDetail(item)}
                                >
                                    Billing Details
                                </span>
                            </td>
                        </tr>)}
                    </tbody>
                </table> : <div className={styles.table_empty}>
                    <InformationIcon />
                    <span>No data.</span>
                </div>}
            </div>
        </div>
    );
};
